import axios from 'axios';
import { config } from '../config';
import SessionService from './SessionService';

const API_URL = config.API_BASE_URL;

export type ProspectLevel = 'aprovar_antes' | 'agir_avisar' | 'autonoma';

export interface ProspectWindowDto {
  /** 0 = domingo. */
  days: number[];
  open: string;
  close: string;
}

export interface ProspectRule {
  id: number;
  sectorId: number;
  name: string;
  enabled: boolean;
  sourceKind: string;
  sourceRef: string;
  agentId: number;
  script: string;
  firstSendLevel: ProspectLevel;
  fallbackText: string | null;
  useFallbackText: boolean;
  window: ProspectWindowDto;
  dailyCap: number;
  maxLeadAgeHours: number;
}

export interface ProspectRuleWrite {
  sectorId: number;
  name: string;
  enabled: boolean;
  sourceKind: 'lead_integration';
  sourceRef: string;
  agentId: number;
  script: string;
  firstSendLevel: ProspectLevel;
  fallbackText: string | null;
  useFallbackText: boolean;
  window: ProspectWindowDto;
  dailyCap: number;
  maxLeadAgeHours: number;
}

export interface ProspectPreview {
  text: string | null;
  decision: string;
  reasonLabel: string | null;
  originBlock: string | null;
  usedFallback: boolean;
}

export interface ProspectLeadStatus {
  eventId: string;
  status: string;
  reason: string | null;
  reasonLabel: string;
  firstSentAtUtc: string | null;
  approvalId: number | null;
}

function authHeaders() {
  return { Accept: 'application/json', Authorization: `Bearer ${SessionService.getToken()}` };
}

function errorMessage(error: unknown, fallback: string) {
  if (axios.isAxiosError(error)) {
    const message = error.response?.data?.message;
    if (typeof message === 'string' && message.trim()) return message;
  }
  return fallback;
}

export async function listRules(sectorId: number): Promise<ProspectRule[]> {
  try {
    const response = await axios.get(`${API_URL}/prospecting/rules`, { params: { sectorId }, headers: authHeaders() });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error(errorMessage(error, 'Não foi possível carregar o contato automático.'));
  }
}

export async function saveRule(input: ProspectRuleWrite): Promise<ProspectRule> {
  try {
    const response = await axios.put(`${API_URL}/prospecting/rules`, input, { headers: authHeaders() });
    return response.data;
  } catch (error) {
    throw new Error(errorMessage(error, 'Não foi possível salvar o contato automático.'));
  }
}

export async function previewRule(sectorId: number, integrationId: string): Promise<ProspectPreview> {
  try {
    const response = await axios.post(`${API_URL}/prospecting/preview`, { sectorId, integrationId }, { headers: authHeaders() });
    return response.data;
  } catch (error) {
    throw new Error(errorMessage(error, 'Não foi possível gerar o exemplo.'));
  }
}

export async function listLeadStatuses(sectorId: number, integrationId: string): Promise<ProspectLeadStatus[]> {
  try {
    const response = await axios.get(`${API_URL}/prospecting/leads`, {
      params: { sectorId, integrationId },
      headers: authHeaders(),
    });
    return Array.isArray(response.data) ? response.data : [];
  } catch {
    return [];
  }
}
